
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/otvorene-lyziarske-strediska",
      function () {
        return require("private-next-pages/[region]/otvorene-lyziarske-strediska.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/otvorene-lyziarske-strediska"])
      });
    }
  